"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = exports.eventSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_types_1 = require("../../shared-types");
const scheduledEvent = shared_types_1.IrrigationScheduler.scheduledEventInputSchema.omit({
    eventId: true,
    fertigationSchedules: true,
});
exports.eventSchema = zod_1.default.array(scheduledEvent);
const scheduledPulseEvent = shared_types_1.IrrigationScheduler.scheduledPulseEventInputSchema.omit({ pulseEventId: true });
exports.requestSchema = zod_1.default.array(scheduledPulseEvent);
exports.path = '/irrigation-scheduler-pulse-events-create';
//# sourceMappingURL=index.js.map